@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Ohio</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Bodily Injury Coverage:</h3>
      <!-- UMBI Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[0].formControlName)?.value === null ||
              reactiveForm.get(controls[0].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UMBI Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[1].formControlName)?.value === null ||
              reactiveForm.get(controls[1].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
            '_ml-large': baseRules?.Show_Indent,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UMBI Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 5; track $index) {
          @if (control.formControlName.startsWith("UMBI") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                  '_ml-large': baseRules?.Show_Indent,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
            [ngClass]="{ '_ml-large': baseRules?.Show_Indent }"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="umbi_splitminlimits_25k_50k-pdffield-ohio">{{ controls[7].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
            [ngClass]="{ '_ml-large': baseRules?.Show_Indent }"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="umbi_combinedsingleminlimit_50k-pdffield-ohio">{{ controls[8].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
      <!-- UMPD Radio group level one -->
      @if (controls?.length >= 3) {
        @if (
          (baseRules?.["SplitLimits_LevelTwoUMBI_Radio"] || "").includes("show") ||
          (baseRules?.["CombinedSingleLimit_LevelTwoUMBI_Radio"] || "").includes("show")
        ) {
          <h3 class="axis-h5 _mt-large">{{ controls[2].label }}</h3>
        }

        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[2].formControlName)?.value === null ||
              reactiveForm.get(controls[2].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              @if (!baseRules?.[control.baseRuleKey]?.includes("readonly")) {
                <axis-radio
                  [hidden]="getRadioButtons(control)"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[2].formControlName }}"
                ></axis-radio>
              }
            }
            @if (reactiveForm.get(controls[2].formControlName)?.touched) {
              @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UMPD Radio Readonly -->
      @if (controls?.length >= 3) {
        <div class="axis-form-group _mt-large">
          @if (baseRules[controls[2].option[0].baseRuleKey] === "Yes") {
            <div class="axis-form-group">
              <label
                class="axis-control-label"
                id="reject_leveloneumpd_radio-pdffield-ohio"
                for=""
                >{{ controls[2].option[0].label }}</label
              >
            </div>
          }
        </div>
      }

      <!-- UMPD Radio group level one -->
      @if (controls?.length >= 4) {
        @if (
          (baseRules?.["Reject_LevelOneUIMBI_Radio"] || "").includes("show") ||
          (baseRules?.["CLimits_LevelOneUIMBI_Radio"] || "").includes("show")
        ) {
          <h3 class="axis-h5 _mt-large">{{ controls[3].label }}</h3>
        }
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[3].formControlName)?.value === null ||
              reactiveForm.get(controls[3].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[3].formControlName)?.touched) {
              @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UIMBI Radio group level two -->
      @if (controls?.length >= 5) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[4].formControlName)?.value === null ||
              reactiveForm.get(controls[4].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[4].formControlName)?.touched &&
              reactiveForm.get(controls[4].formControlName)?.invalid,
            '_ml-large': baseRules?.Show_Indent,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[4].formControlName }}">
            @for (control of controls[4].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[4].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[4].formControlName)?.touched) {
              @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UIMBI Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 9; track $index) {
          @if (control.formControlName.startsWith("UIMBI") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                  '_ml-large': baseRules?.Show_Indent,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["UIMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
            [ngClass]="{ '_ml-large': baseRules?.Show_Indent }"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[11].label }}</label>
              <div id="uimbi_splitminlimits_50k_100k-pdffield-ohio">{{ controls[11].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["UIMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div
            class="axis-col-sm-6 axis-col-lg-4"
            [ngClass]="{ '_ml-large': baseRules?.Show_Indent }"
          >
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="uimbi_combinedsingleminlimit_75k-pdffield-ohio">{{ controls[12].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Ohio</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOneUMBI_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UMBI }}
      </label>
    </div>
  }
  @if (baseRules?.Reject_LevelOneUMPD_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UMPD }}
      </label>
    </div>
  }

   @if (baseRules?.Limits_LevelOneUMPD_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ controls[2].option[1].label }} 
      </label>
    </div>
  }
  

  @if (baseRules?.Reject_LevelOneUIMBI_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UIMBI }}
      </label>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 5; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>

 
}
